// Shared DOM id for the notifications bell's portal target, rendered by the app-wide
// Navigation header (src/components/Layout/Header/Navigation.jsx). Whichever page owns the
// real Stream data (feed or chat) portals its own NotificationsPopover into this slot, so the
// bell always shows in the top navigation without the header needing to know about Stream.
export const NAVIGATION_NOTIFICATIONS_SLOT_ID = 'navigation-notifications-slot'
